const defaultValues = {
  name: "dish-int",
  type: "silo | pool-infra",
  version: "24.5.2",
  region: "us-east-1",
  zone: "us-east-1a",
  profile: {
    nodegroups: [
      {
        name: "master",
        minSize: 0,
        maxSize: 50,
        desiredSize: 3,
        instanceTypes: "m5.4xlarge",
        disk: "100Gi",
      },
      {
        name: "worker",
        minSize: 0,
        maxSize: 50,
        desiredSize: 5,
        instanceTypes: "m5.4xlarge",
        disk: "100Gi",
      },
      {
        name: "database",
        minSize: 0,
        maxSize: 50,
        desiredSize: 3,
        instanceTypes: "m5.4xlarge",
        disk: "100Gi",
      },
    ],
    hadoop: [
      {
        name: "zookeeper",
        replicas: 3,
        core: "500m",
        memory: "2Gi",
        dataDisk: "1Gi",
        logDisk: "20Gi",
        javaOpts: "-Xmx1600m"
      },
      {
        name: "hadoop-hdfs-nn",
        replicas: 2,
        core: "2000m",
        memory: "4Gi",
        dataDisk: "10Gi",
        javaOpts: "-Xmx3600m"
      },
      {
        name: "hadoop-hdfs-jn",
        replicas: 3,
        core: "1000m",
        memory: "2Gi",
        dataDisk: "10Gi",
        javaOpts: "-Xmx1600m"
      },
      {
        name: "hadoop-hdfs-dn",
        replicas: 5,
        core: "2000m",
        memory: "4Gi",
        dataDisk: "500Gi",
        javaOpts: "-Xmx3600m"
      },
      {
        name: "spark-master",
        replicas: 3,
        core: "2000m",
        memory: "2Gi"
      },
      {
        name: "spark-worker",
        replicas: 5,
        core: "13000m",
        memory: "54Gi",
        workerMem: "58G",
        dataDisk: "50Gi",
      },
    ],
    mysql: [
      {
        name: "mysql",
        replicas: 3,
        core: "12000m",
        memory: "48Gi",
        dataDisk: "500Gi",
        poolSize: "10G",
      },
      {
        name: "mysql-router",
        replicas: 3,
        core: "3000m",
        memory: "10Gi",
      },
      {
        name: "mysql-console",
        replicas: 1,
        core: "100m",
        memory: "500Mi",
        dataDisk: "200Gi",
      },
    ],
    via: [
      {
        name: "via-ds",
        replicas: 2,
        core: "2000m",
        memory: "6Gi",
        dataDisk: "50Gi",
        javaOpts: "-Xms4g -Xmx6g",
      },
      {
        name: "via-rs",
        replicas: 3,
        core: "3000m",
        memory: "10Gi",
        dataDisk: "100Gi",
        javaOpts: "-Xms4g -Xmx4g",
      },
      {
        name: "via-ps",
        replicas: 2,
        core: "4000m",
        memory: "30Gi",
        dataDisk: "200Gi",
        javaOpts: "-Xms8g -Xmx28g -XX:MaxDirectMemorySize=1g",
      },
    ],
    aiops: [
      {
        name: "aiops",
        replicas: 1,
        core: "500m",
        memory: "255Mi",
        dataDisk: "1Gi",
        variables: [
          { name: "ODA_EXECUTOR_MEMORY", value: "6g" },
          { name: "ODA_DRIVER_MEMORY", value: "6g" },
        ],
      },
    ],
  },
};

const serverDefaultVersion = {
  "zookeeper.version": "5.2.1",
  "hadoop-hdfs-nn.version": "2.7.5.2",
  "hadoop-hdfs-jn.version": "2.7.5.2",
  "hadoop-hdfs-dn.version": "2.7.5.2",
  "spark-master.version": "2.3.1.2",
  "spark-worker.version": "2.3.1.2",
  "mysql.version": "vt5.7.30.1",
  "mysql-router.version": "vt8.0.19",
  "mysql-console.version": "vt8.0.28.1",
  "via-ds.version": "6.1.0.20-v3.1_MT",
  "via-rs.version": "6.1.0.20-v3.1_MT",
  "via-ps.version": "6.1.0.20-v3.1_MT",
};

export const deriveUIDefaultsFromServerFormat = (profile) => {
  const result = {};
  Object.keys(profile).forEach((key) => {
    const items = profile[key];
    if (Array.isArray(items)) {
      items.forEach((item) => {
        const itemName = item.name;
        Object.keys(item).forEach((itemKey) => {
          if (itemKey !== "name")
            result[`${itemName}.${itemKey}`] = item[itemKey];
        });
      });
    }
  });

  return result;
};

export const getWizardUIDefaultValue = () => {
  const profile = defaultValues.profile;
  const initialValue = deriveUIDefaultsFromServerFormat(profile);
  const ret = { ...initialValue, ...serverDefaultVersion };
  return ret;
};
export const appendDefaultValuesToColumns = (columns, defaultValues) => {
  const updateColumns = columns.map((row) => {
    return row.map((column) => {
      if (
        typeof column === "object" &&
        column !== null &&
        "dataIndex" in column
      ) {
        const dataIndex = column.dataIndex;

        if (defaultValues.hasOwnProperty(dataIndex)) {
          return { ...column, initialValue: defaultValues[dataIndex] };
        }
      } else if (
        typeof column === "object" &&
        column !== null &&
        column.valueType !== "dependency" &&
        "columns" in column
      ) {
        const columns = appendDefaultValuesToColumns(
          [column.columns],
          defaultValues,
        );
        return { ...column, columns: columns[0] };
      }

      return column;
    });
  });
  return updateColumns;
};

const filterBasedKeys = (originalObject, keysToMatch) => {
  const data = { ...originalObject, ...serverDefaultVersion };
  const newObject = Object.entries(data).reduce((acc, [key, value]) => {
    if (keysToMatch.some((k) => key.indexOf(k) == 0)) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return newObject;
};

export const getNodegroupTemplate = (templateValue) => {
  const keysToMatch = ["master", "worker", "database", "druid-master", "druid-worker"];
  return filterBasedKeys(templateValue, keysToMatch);
};

export const getHadoopTemplate = (templateValue) => {
  const keysToMatch = [
    "zookeeper",
    "hadoop-hdfs-nn",
    "hadoop-hdfs-jn",
    "hadoop-hdfs-dn",
    "spark-master",
    "spark-worker",
  ];
  return filterBasedKeys(templateValue, keysToMatch);
};

export const getMySQLTemplate = (templateValue) => {
  const keysToMatch = ["mysql", "mysql-router", "mysql-console", "mysql-master"];
  const filtered = filterBasedKeys(templateValue, keysToMatch);
  // A profile stored before mysql-master's nodegroup field existed has the "mysql-master"
  // item but no "mysql-master.nodegroup" key on it at all (unlike gitea's, which has always
  // shipped with the field even from before it was read), leaving the Update MySQL form's
  // select empty. MySQLNonHAHelm.overrideValues() defaults to "master" server-side when this
  // is missing -- mirror that here so the form shows a real initial value instead of blank.
  if (!filtered.hasOwnProperty("mysql-master.nodegroup")) {
    filtered["mysql-master.nodegroup"] = "master";
  }
  return filtered;
};

export const getDruidTemplate = (templateValue) => {
  const keysToMatch = ["druid-zookeeper", "coordinator", "broker", "router", "middleManager", "historical", "druid-all", "env"];
  return filterBasedKeys(templateValue, keysToMatch);
}

// Canonical gitea profile entry. Mirrors Constants.GITEA_DEFAULT_PROFILE on the provisioner
// side; the two must agree. Defined here because this module has no imports of its own, so it
// cannot participate in an import cycle.
export const GITEA_DEFAULT_PROFILE = {
  name: "gitea",
  replicas: 1,
  nodegroup: "master",
  core: "500m",
  memory: "1Gi",
  dataDisk: "20Gi",
};

export const getGiteaTemplate = (templateValue) => {
  const keysToMatch = ["gitea"];
  const filtered = filterBasedKeys(templateValue, keysToMatch);
  // A profile template stored in the global DB before gitea existed carries no gitea.* keys at
  // all, and that DB row takes precedence over the shipped profile_*.yaml -- nothing migrates it.
  // Without a fallback the wizard's Gitea step renders with every field blank, which is both
  // useless and unsubmittable. Seed it from the canonical entry instead. This covers BOTH
  // wizards, since useWizardColumnsConfig and useProfileWizardConfig share this template fn.
  const hasGitea = Object.keys(filtered).some((k) => k.indexOf("gitea.") === 0);
  if (!hasGitea) {
    return {
      ...filtered,
      ...deriveUIDefaultsFromServerFormat({ gitea: [GITEA_DEFAULT_PROFILE] }),
    };
  }
  return filtered;
};

// Canonical neo4j profile entry. Mirrors Constants.NEO4J_DEFAULT_PROFILE on the provisioner
// side; the two must agree. Defined here for the same import-cycle reason as
// GITEA_DEFAULT_PROFILE above.
export const NEO4J_DEFAULT_PROFILE = {
  name: "neo4j",
  replicas: 1,
  nodegroup: "database",
  core: "4000m",
  memory: "16Gi",
  dataDisk: "100Gi",
  heapInitialSize: "6g",
  heapMaxSize: "6g",
  pagecacheSize: "8g",
};

export const getNeo4jTemplate = (templateValue) => {
  const keysToMatch = ["neo4j"];
  const filtered = filterBasedKeys(templateValue, keysToMatch);
  // Same reasoning as getGiteaTemplate above: a profile template stored before neo4j existed
  // carries no neo4j.* keys, so fall back to the canonical entry.
  const hasNeo4j = Object.keys(filtered).some((k) => k.indexOf("neo4j.") === 0);
  if (!hasNeo4j) {
    return {
      ...filtered,
      ...deriveUIDefaultsFromServerFormat({ neo4j: [NEO4J_DEFAULT_PROFILE] }),
    };
  }
  return filtered;
};

export const getVIATemplate = (templateValue) => {
  const keysToMatch = ["via-ds", "via-rs", "via-ps", "via-fs", "via-all"];
  return filterBasedKeys(templateValue, keysToMatch);
};

export const getAIOpsTemplate = (templateValue) => {
  const keysToMatch = ["aiops"];
  return filterBasedKeys(templateValue, keysToMatch);
};

export const empty = () => ({});
